export default __webpack_public_path__ + "static/claromentis-ds-logo@2x-45d38cc8448c049df952eb6d13051468.png";